import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ClientReportPopover from '/component/partial/reportCard/ClientReportPopover';
import CoachReportPopover from '/component/partial/reportCard/CoachReportPopover';
import {CLIENT_REPORT, COACH_REPORT} from '/enum/popover.enum';
import {FETCH_TGENV_VOLUME} from '/enum/request.enum';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {getAnalyticsUtilDefaultInstance} from '/util/analytics/analytics.util';
import {withProps} from '/util/selector.util';

const POPOVER_COMPONENTS = {
  [CLIENT_REPORT]: ClientReportPopover,
  [COACH_REPORT]: CoachReportPopover,
};

export default ({
  reportPayload,
  popoverName,
  popoverContentName,
  popoverContentProps,
  addCoachToWatchlist,
  removeCoachFromWatchlist,
  refreshWatchlistCoaches,
}: any) =>
  connect(
    createStructuredSelector({
      userId,
      lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    }),
    null,
    (stateProps, dispatchProps, ownProps) => ({
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      showRecordPopover: getShowRecordPopover({
        reportPayload,
        popoverName,
        popoverContentName,
        popoverContentProps,
        lastPaidRank: stateProps.lastPaidRank,
        addCoachToWatchlist,
        removeCoachFromWatchlist,
        refreshWatchlistCoaches,
      }),
    }),
  );

export const getShowRecordPopover = ({
  reportPayload,
  popoverName,
  popoverContentName,
  popoverContentProps,
  lastPaidRank,
  addCoachToWatchlist,
  removeCoachFromWatchlist,
  refreshWatchlistCoaches,
}: any) => {
  return (
    recordParams: any,
    {recordsShowPopover, recordsShowRecord, recordExtras, onOrderPress}: any,
  ) => {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const PopoverComponent = POPOVER_COMPONENTS[popoverName];

    let defaultExtras = {};

    if (popoverName === COACH_REPORT) {
      defaultExtras = {
        tgenv: {endpoint: FETCH_TGENV_VOLUME, params: recordParams},
      };
    }

    if (PopoverComponent) {
      recordsShowPopover(PopoverComponent, {
        recordsName: reportPayload.reportName || reportPayload.recordsName,
        recordParams,
        recordExtras: {...defaultExtras, ...recordExtras},
        contentName: popoverContentName,
        contentProps: popoverContentProps,
        onViewProfilePress: recordsShowRecord,
        onOrderPress: onOrderPress,
        lastPaidRank: lastPaidRank,
        addCoachToWatchlist,
        removeCoachFromWatchlist,
        refreshWatchlistCoaches,
        onShowWithRecordData: () => {
          const {recordsName} = reportPayload;
          getAnalyticsUtilDefaultInstance().trackReportCardView({
            recordsName,
            recordsCardName: popoverName,
          });
        },
      });
    }
  };
};
